import type { FaireProductEntity } from "../../entity_types/product";

export const p_k6gcf59us3: FaireProductEntity = {
  token: "p_k6gcf59us3",
  type: "product",
  name: "Mums And Robins Swedish Cloth Set",
  brandToken: "b_4knjkc8j",
  brandName: "Primitives by Kathy",
  imageUrl: "https://cdn.faire.com/fastly/f54893f93e62cbc70947ff94880c0b9183d3f62c2934aa24c763c1324a00996a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f954eedab890beb889ae8393e857cc4ec16bac0a12ce48738fbe4ef81d0946a4.jpeg",
    "https://cdn.faire.com/fastly/e16085920111439373fc032d5397847ea5aee0660687d2261e1545a813307aed.jpeg",
    "https://cdn.faire.com/fastly/1cc4c2bb5beefec6337560cd56f3c870ad6cde02593b78913c6a4dce8f0f18e9.jpeg",
    "https://cdn.faire.com/fastly/4958eaaafb2de3c9f8e49aec074770c63792f48e0a8e1cc12222b79d96e260f0.jpeg"
  ],
  priceDollars: 5.5,
  description: "Safe to use on all types of surfaces, eco-friendly Swedish Dishcloths dry quickly and are antibacterial for more hygienic cleaning with reduced waste. This set of 2 Swedish Dishcloths from our Folk Art Collection features intricate flower patterns with robins and monarch butterflies on each cloth. Botanical designs are replicated from original hand illustrated art inspired by folk art. Our Mums And Robins Swedish dishcloth set is ultra-absorbent and conveniently machine washable for easy cleaning and reuse. Dishcloths are attached to header card with hole for easy store rack display. A stylish garden-themed set of reusable dishcloths perfect for replacing dull sponges and paper towels with long-lasting colorful designs.",
  tags: [],
  msrpDollars: 10.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:04:20.525Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
